import toast from "react-hot-toast";
import {BaseClient} from "../../Api/HttpClient";
import {transformObjectToGetRequestParams} from "../../Utils/HttpHelper";

export const createExportExcelSlice = (set, get) => ({
    getExportForStatisticsForCustomer: async (customer_id, start_date= null , end_date = null) => {
        return await BaseClient().get(
            `/export/customers/${customer_id}/shifts?` + transformObjectToGetRequestParams({start_date, end_date}),
            {responseType: 'arraybuffer'}
        )
            .then(response => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    toast.error(response.data);
                }
            })
    }
})